import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import TaskStatusIcon, {TASK_STATUS_ICONS} from 'processes/status/TaskStatusIcon';
import {ChipSize} from 'ui-library/chips/Chip';
import WorksheetChip from 'ui-library/chips/WorksheetChip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {PLANNED, UnitOperationStatusType} from '../process-development/useProcessDevelopmentStudyProgress';

export function RenderWorksheetChip({worksheetId}: {worksheetId: string | null}): JSX.Element {
  if (worksheetId == null) {
    return <span>---</span>;
  } else {
    return <WorksheetChip id={worksheetId} className={css(styles.chipText)} size={ChipSize.MINI} />;
  }
}

export function RenderTaskStatus({statusType}: {statusType: UnitOperationStatusType | null}): JSX.Element {
  return <RenderTaskStatusWithIcon statusType={statusType ?? PLANNED} />;
}

export function RenderTaskStatusWithIcon({statusType}: {statusType: UnitOperationStatusType}): JSX.Element {
  if (statusType === PLANNED) {
    return (
      <div className={css(styles.statusContainer)}>
        <BenchlingIcon icon="calendar-days" className={css(styles.plannedIcon)} />
        <span>Planned</span>
      </div>
    );
  } else {
    return (
      <div className={css(styles.statusContainer)}>
        <TaskStatusIcon type={statusType} />
        <span>{TASK_STATUS_ICONS[statusType].name}</span>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  statusContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  plannedIcon: {
    marginRight: 6,
  },
  chipText: {
    whiteSpace: 'nowrap',
  },
});
